/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from 'assets/theme/base/colors'
import typography from 'assets/theme/base/typography'
import boxShadows from 'assets/theme/base/boxShadows'

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from 'assets/theme/functions/pxToRem'

const { transparent, light, info, secondary } = colors
const { size } = typography
const { buttonBoxShadow } = boxShadows

const parcoRounded = {
  base: {
    padding: '8px 24px',
    backgroundColor: '#2370ED',
    border: '2px solid #2370ED',
    color: '#fff',
    boxShadow: 'none',
    borderRadius: '100px',
    textTransform: 'capitalize',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: 1.5,

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      transform: 'none',
      backgroundColor: '#1c59bd',
      borderColor: '#1c59bd',
      boxShadow: 'none',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(34),
    padding: `${pxToRem(6)} ${pxToRem(12)}`,
    fontSize: size.xs,

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(49),
    padding: `${pxToRem(14)} ${pxToRem(64)}`,
    fontSize: '24px',

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  outline: {
    backgroundColor: '#FFF',
    border: '2px solid #262627',
    color: '#262627',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      backgroundColor: '#f1f1f1',
      border: '2px solid #262627',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },

  error: {
    backgroundColor: '#FF2F32',
    border: '2px solid #FF2F32',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      backgroundColor: '#e52a2d',
      border: '2px solid #e52a2d',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },

  outlineError: {
    backgroundColor: '#FFF',
    border: '2px solid #FF2F32',
    color: '#FF2F32',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      backgroundColor: '#ffeaea',
      border: '2px solid #e52a2d',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },

  secondary: {
    backgroundColor: '#262627',
    border: '2px solid #262627',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      backgroundColor: '#262627',
      border: '2px solid #262627',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },

  signal: {
    background: 'linear-gradient(96deg, #F0574C 11%, #4E41DF 94%)',
    border: '2px solid transparent',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      background: 'linear-gradient(96deg, #d84e44 11%, #463ac8 94%)',
      border: '2px solid transparent',
    },
    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },

  multi: {
    background:
      'linear-gradient(115deg, #DEF5FA 0.15%, #F1E9F5 41.92%, #EDF4FE 88.81%)',
    border: '2px solid #262627',
    color: '#262627',

    '&:hover, &:focus, &:active, &:focus:not(:hover)': {
      background:
        'linear-gradient(115deg, #c7dce1 0.15%, #d8d1dc 41.92%, #d5dbe4 88.81%)',
      border: '2px solid #262627',
    },

    '&:disabled': {
      borderColor: 'rgba(0,0,0,0)',
      backgroundColor: 'rgba(0,0,0,0.15)',
    },
  },
}

export default parcoRounded
